import styled, { css } from 'styled-components';

interface ImageProps {
  isSmall: boolean;
}

export const Container = styled.div`
  border: 2px dashed;
  margin-top: 24px;
  padding: 24px;
  display: flex;
  width: 100%;
  flex-direction: column;
  border-radius: 8px;

  > p {
    font-family: Roboto;
    font-size: 16px;
    font-weight: 600;
    line-height: 22.5px;
    text-align: left;
    margin: 0;
    padding: 0;
  }
`;

export const ResponsiveContainer = styled.div`
  display: flex;
  margin: 16px 0;
  gap: 16px;
  align-items: center;
  word-wrap: break-word;
`;

export const DescriptionContent = styled.div`
  flex: 1;
  width: 100%;
  overflow: hidden;

  text-overflow: ellipsis;
  > p {
    all: unset;

    font-family: Roboto;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: justify;
  }
`;

export const CheckContent = styled.div`
  padding: 8px;
  display: flex;
  gap: 8px;
  align-items: center;
  border: 1px solid;
  border-radius: 8px;
`;

export const Image = styled.img<ImageProps>`
  height: 100px;
  object-fit: cover;
  border-radius: 8px;

  ${({ isSmall }) =>
    isSmall
      ? css`
          width: 100%;
          height: 100px;
          object-fit: cover;
          border-radius: 8px;
        `
      : css`
          flex: 0.5;
        `}
`;
